export function normalizeMembershipApplicationStatus(application) {
    return String(application?.status || "").trim().toLowerCase();
}

export function isAcceptedMembershipApplication(application) {
    return Boolean(application?.exists) && normalizeMembershipApplicationStatus(application) === "accepted";
}

export function getProfessionalPlanAccessDecision({ groupAuthorized, membershipApplication }) {
    if (groupAuthorized) {
        return { allowed: true, source: "group" };
    }

    if (isAcceptedMembershipApplication(membershipApplication)) {
        return { allowed: true, source: "membership_application" };
    }

    return { allowed: false, source: "none" };
}

export async function getMembershipApplicationFallbackDecision({
    getAccessToken,
    getMyMembershipApplication,
}) {
    const accessToken = await getAccessToken();
    const membershipApplication = await getMyMembershipApplication(accessToken);

    return getProfessionalPlanAccessDecision({
        groupAuthorized: false,
        membershipApplication,
    });
}
